import React from "react";
export default function ResultError() {
	return (
		<div>
			<div className="flex flex-col space-x-0 items-center mx-auto text-center justify-between mb-12 md:max-w-lg">
				<h2 className="block text-xl text-primary mb-2">
					We have encountered an error.
				</h2>
				<p>Please try again.</p>
			</div>
		</div>
	);
}
